<!-- <template>
  <div class="d-flex flex-wrap justify-content-xl-between fontsize-small order-xl-1 order-2">
    <button :disabled="filter.sort == 'most_visited' || loading"
            :class="filter.sort == 'most_visited' ? 'view-order-active' : ''"
            @click="filter.sort = 'most_visited' , productsFilter()" type="button"
            class="ml-1 py-2 px-3 text-color-999  ">
      پربازدید ترین
    </button>
    <button :disabled="filter.sort == 'low_to_high' || loading"
            :class="filter.sort == 'low_to_high' ? 'view-order-active' : ''"
            @click="filter.sort = 'low_to_high' , productsFilter()" type="button"
            class="ml-1 py-2 px-3 text-color-999  ">
      ارزان ترین
    </button>
    <button :disabled="filter.sort == 'high_to_low' || loading"
            :class="filter.sort == 'high_to_low' ? 'view-order-active' : ''"
            @click="filter.sort = 'high_to_low' , productsFilter()" type="button"
            class="ml-1 py-2 px-3 text-color-999  ">
      گران ترین
    </button>
    <button :disabled="filter.sort == 'top_sales' || loading"
            :class="filter.sort == 'top_sales' ? 'view-order-active' : ''"
            @click="filter.sort = 'top_sales' , productsFilter()" type="button"
            class="ml-1 py-2 px-3 text-color-999  ">
      پرفروش ترین
    </button>
    <button :disabled="filter.sort == 'newest' || loading"
            :class="filter.sort == 'newest' ? 'view-order-active' : ''"
            @click="filter.sort = 'newest' , productsFilter()" type="button"
            class="ml-1 py-2 px-3 text-color-999  ">
      جدید ترین
    </button>
    <button :disabled="filter.sort == 'most_discount' || loading"
            :class="filter.sort == 'most_discount' ? 'view-order-active' : ''"
            @click="filter.sort = 'most_discount' , productsFilter()" type="button"
            class="ml-1 py-2 px-3 text-color-999  ">
      ویژه
    </button>
  </div>
</template>
<script>
import cloneDeep from 'lodash/cloneDeep'

export default {
  name: "ProductsSort",
  props: {
    value: Object,
    loading: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      filter: cloneDeep(this.value)
    }
  },
  watch: {
      value(newVal) {
        this.filter = cloneDeep(newVal)
      }
  },
  computed: {
    disabled() {
      return this.$store.getters['front/getProductsStatus']
    },
  },
  methods: {
    productsFilter() {
      this.filter.page = 1
      this.$emit('input', this.filter)
    }
  }
}
</script>
<style scoped>
.view-order-active {
  color: var(--color-theme) !important;
  background-color: var(--color-theme2) !important;
}
</style> -->



<template>
  <div
    class="d-flex flex-wrap justify-content-xl-between fontsize-small order-xl-1 order-2"
  >
    <!-- <button :disabled="filter.sort == 'most_visited' || loading"
            :class="filter.sort == 'most_visited' ? 'view-order-active' : ''"
            @click="filter.sort = 'most_visited' , productsFilter()" type="button"
            class="ml-1 py-2 px-3 text-color-999  ">
      پربازدید ترین
    </button>
    <button :disabled="filter.sort == 'low_to_high' || loading"
            :class="filter.sort == 'low_to_high' ? 'view-order-active' : ''"
            @click="filter.sort = 'low_to_high' , productsFilter()" type="button"
            class="ml-1 py-2 px-3 text-color-999  ">
      ارزان ترین
    </button>
    <button :disabled="filter.sort == 'high_to_low' || loading"
            :class="filter.sort == 'high_to_low' ? 'view-order-active' : ''"
            @click="filter.sort = 'high_to_low' , productsFilter()" type="button"
            class="ml-1 py-2 px-3 text-color-999  ">
      گران ترین
    </button>
    <button :disabled="filter.sort == 'top_sales' || loading"
            :class="filter.sort == 'top_sales' ? 'view-order-active' : ''"
            @click="filter.sort = 'top_sales' , productsFilter()" type="button"
            class="ml-1 py-2 px-3 text-color-999  ">
      پرفروش ترین
    </button>
    <button :disabled="filter.sort == 'newest' || loading"
            :class="filter.sort == 'newest' ? 'view-order-active' : ''"
            @click="filter.sort = 'newest' , productsFilter()" type="button"
            class="ml-1 py-2 px-3 text-color-999  ">
      جدید ترین
    </button>
    <button :disabled="filter.sort == 'most_discount' || loading"
            :class="filter.sort == 'most_discount' ? 'view-order-active' : ''"
            @click="filter.sort = 'most_discount' , productsFilter()" type="button"
            class="ml-1 py-2 px-3 text-color-999  ">
      ویژه
    </button> -->

    <form class="d-flex align-items-center">
      <p class="m-0 ml-2">فیلتر :</p>
      <div class="selction-filter-form">
        <select v-model="filter_option" id="selction-filter" class="selction-filter">
          <option
            value="most_visited"
            :class="{ 'bg-option': filter_option == value }"
          >
            پربازدید ترین
          </option>
          <option
            value="low_to_high"
            :class="{ 'bg-option': filter_option == value }"
          >
            ارزان ترین
          </option>
          <option
            value="high_to_low"
            :class="{ 'bg-option': filter_option == value }"
          >
            گران ترین
          </option>
          <option
            value="top_sales"
            :class="{ 'bg-option': filter_option == value }"
          >
            پرفروش ترین
          </option>
          <option value="newest" :class="{ 'bg-option': filter_option == value }">
            جدید ترین
          </option>
          <option
            value="most_discount"
            :class="{ 'bg-option': filter_option == value }"
          >
            ویژه
          </option>
        </select>
        <label for="selction-filter" class="lable-selction-filter">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 256 256" class="absolute top-1/2 -translate-y-1/2 md:right-4 right-2"><path d="M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z"></path></svg>
        </label>
      </div>
    </form>
  </div>
</template>
<script>
import cloneDeep from "lodash/cloneDeep";

export default {
  name: "ProductsSort",
  props: {
    value: Object,
    loading: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      filter: cloneDeep(this.value),
      filter_option: this.$route.query.sort ?? "most_visited",
    };
  },
  watch: {
    value(newVal) {
      // this.filter = cloneDeep(newVal)
    },
    filter_option(newVal) {
      this.filter.sort = newVal;
      this.productsFilter();
     
    },
  },
  computed: {
    disabled() {
      return this.$store.getters["front/getProductsStatus"];
    },
  },
  methods: {
    productsFilter() {
      this.filter.page = 1;
      this.$emit("input", this.filter);
    },
  },
};
</script>
<style scoped>
.selction-filter-form{
  position: relative;
  border: 1px solid rgb(233 233 233);
  border-radius: 0.5rem;
  background-color: #ffffff;
}
.lable-selction-filter{
  position: absolute;
  left: 3%;
  top: 50%;
  transform: translateY(-50%);
 
}
.selction-filter {
  padding: .5rem .75rem .5rem 6rem;
  outline: unset;
  border: unset;
  background-color: transparent;
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;
  appearance: none;
  outline: none;
}
.bg-option {
  background: rgba(100, 100, 100, 0.3);
}
.view-order-active {
  color: var(--color-theme) !important;
  background-color: var(--color-theme2) !important;
}
</style>
